@if (!deviceService.isMobile()) {
  <footer id="footerBar" class="bg-body-tertiary shadow-sm p-3 text-center">
    <div class="d-flex justify-content-between align-items-center">
      <h2 class="h5 mb-0 text-body">Copyright © La taverna del Lupo.</h2>
      <div class="d-flex align-items-center gap-2">
        <small class="text-muted">v{{ version() }}</small>
        <a href="https://boardgamegeek.com" target="_blank" rel="noopener" title="BoardGameGeek">
          <img src="https://cf.geekdo-images.com/HZy35cmzmmyV9BarSuk6ug__small/img/gbE7sulIurZE_Tx8EQJXnZSKI6w=/fit-in/200x150/filters:strip_icc()/pic7779581.png"
               alt="BGG" style="height: 30px; width: auto;">
        </a>
      </div>
    </div>
  </footer>
}

@if (deviceService.isMobile()) {
  <footer class="mobile-footer bg-body-tertiary border-top">
    <div class="container-fluid">
      <div class="row text-center py-2">
        @for (button of footerButtons; track button.elementId) {
          @if (!button.showCondition || button.showCondition()) {
            <div class="col">
              <a [routerLink]="button.routerLink"
                 (click)="button.action ? button.action() : null"
                 class="text-decoration-none text-body d-flex flex-column align-items-center"
                 style="cursor: pointer;">
                @if (button.icon) {
                  <i [class]="button.icon + ' fs-4'"></i>
                }
                <span class="small">{{ button.label }}</span>
              </a>
            </div>
          }
        }
      </div>
      <div class="row text-center pb-2 border-top pt-1">
        <div class="col-12 d-flex justify-content-center align-items-center gap-2">
          <small class="text-muted">v{{ version() }}</small>
          <a href="https://boardgamegeek.com" target="_blank" rel="noopener" title="BoardGameGeek">
            <img src="https://cf.geekdo-images.com/HZy35cmzmmyV9BarSuk6ug__small/img/gbE7sulIurZE_Tx8EQJXnZSKI6w=/fit-in/200x150/filters:strip_icc()/pic7779581.png"
                 alt="BGG" style="height: 24px; width: auto;">
          </a>
        </div>
      </div>
    </div>
  </footer>
}
